import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/LoginNew.vue'
import Dashboard from '../views/Dashboard.vue'
import Kunden from '../views/Kunden.vue'
import Mitarbeiter from '../views/Mitarbeiter.vue'
// import Auftraege from '../views/Auftraege.vue'
import Auftraege from '../views/AuftraegeView.vue'
import DruckplannungView from "@/views/DruckplannungView.vue";
import NewKunde from "@/components/NewKunde.vue";
import KundeView from "@/views/kunde/ShowView.vue"

import AuftragShowView from '@/views/orders/ShowView.vue'
import AuftragEdit from '@/views/orders/EditView.vue'
import KapazitaetplannungView from "@/views/KapazitaetplannungView.vue";
import DeliveryView from "@/views/DeliveryView.vue"
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    // Tablet-Vollbildmaske an der Maschine (#16). Bewusst NICHT unter dem
    // Dashboard: kein Menü, keine Sidebar — der Bildschirm gehört dem Drucker.
    path: '/schicht',
    name: 'Schichtansicht',
    component: () => import('@/views/SchichtView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Home',
        // Startseite: Kap.Pl.-Übersicht + Abholliste (Besprechung 2026-06-05).
        component: () => import('@/views/HomeView.vue')
      },
      {
        path: 'ich',
        name: 'Meine Seite',
        beforeEnter: (to, from, next) => {
          try {
            const userData = JSON.parse(localStorage.getItem('user') || '{}')
            if (userData.id) {
              next(`/mitarbeiter/${userData.id}`)
            } else {
              next('/auftraege')
            }
          } catch {
            next('/auftraege')
          }
        },
        component: Kunden // fallback, won't render due to redirect
      },
      {
        path: 'kunden',
        name: 'Kunden',
        component: Kunden
      },
      {
        path: '/kunden/:id',
        name: 'CustomerShow',
        component: () => import('@/views/customer/Show.vue')
      },
      {
        path: 'mitarbeiter',
        name: 'Mitarbeiter',
        component: Mitarbeiter
      },
      {
        path: 'mitarbeiter/:id',
        name: 'MitarbeiterShow',
        component: () => import('@/views/mitarbeiter/ShowView.vue'),
        props: true
      },
      // {
      //   path: 'Druckplannung',
      //   name: 'Druckplannung',
      //   component: DruckplannungView
      // },
      {
        path: 'Delivery',
        name: 'Delivery',
        component: DeliveryView
      },
      {
        path: '/lieferungen/:id',
        name: 'DeliveryShow',
        component: () => import('@/views/delivery/Show.vue'),
        props: true
      },
      {
        path: 'Druckplannung',
        name: 'Kapazitaetplannung',
        component: KapazitaetplannungView
      },
      {
        path: 'auftraege',
        name: 'Auftraege',
        component: Auftraege
      },

      {
        path: 'auftraege/:id',
        name: 'auftrag-show',
        component: AuftragShowView,
        props: true
      },
      // Individual Auftrag edit (requires owner role)
      {
        path: 'auftraege/:id/edit',
        name: 'AuftragEdit',
        component: AuftragEdit,
        meta: {
          title: 'Auftrag bearbeiten',
          requiresAuth: true,
          requiresCapability: 'edit_any_order'
        },
        props: true
      },
      {
        path: 'abholliste',
        name: 'Abholliste',
        component: () => import('@/views/AbhollisteView.vue')
      },
      {
        path: 'projectmanagement',
        name: 'Projektverwaltung',
        component: () => import('@/views/ProjectManagementView.vue'),
        meta: { requiresAuth: true, requiresCapability: 'manage_users' }
      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('@/views/admin/Index.vue'),
        // „Besitzer" = A-Admin. Der Guard blendet nur aus; erzwungen wird es
        // im Backend über require_capability!(:can_manage_backups?).
        meta: { requiresAuth: true, requiresCapability: 'manage_backups' }
      },
      {
        path: 'admin/machines',
        name: 'MachinesAdmin',
        component: () => import('@/views/admin/Machines.vue'),
        meta: { requiresAuth: true, requiresCapability: 'admin_machines' }
      },
      {
        path: '/papierbestellungen',
        name: 'PaperOrders',
        component: () => import('@/views/paper_orders/Index.vue')
      },
      {
        path: '/papierbestellungen/:id',
        name: 'PaperOrderShow',
        component: () => import('@/views/paper_orders/Show.vue'),
        props: true
      },
      {
        // #49 Rest-Papiere — leftover paper stock
        path: '/restpapiere',
        name: 'RestPapiere',
        component: () => import('@/views/rest_papers/Index.vue')
      },
      {
        path: 'kunden/:id',
        name: 'kunden-show',
        component: KundeView,
        props: true
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  if (to.matched.some(record => record.meta.requiresAuth) && !token) {
    return next('/login')
  }

  // Fähigkeits-Guard — Backend erzwingt ebenfalls, das hier blendet nur die
  // Ansicht aus. Fähigkeiten kommen aus der User#abilities-Map (im gespeicherten
  // User); einzige Quelle der Wahrheit, keine Rollen-Strings mehr.
  const capRule = to.matched.find(r => r.meta && r.meta.requiresCapability)
  if (capRule) {
    let abilities = {}
    try { abilities = JSON.parse(localStorage.getItem('user') || '{}').abilities || {} } catch { abilities = {} }
    if (!abilities[capRule.meta.requiresCapability]) {
      return next('/auftraege')
    }
  }

  next()
})

export default router
